
export default {
  components: {
    hotHotmartAppNewHero: () => import('~/components/Organisms/HotmartAppNewHero/HotmartAppNewHero.vue'),
    OrganicModal: () => import('~/components/Molecules/Organic/Modal/Modal.vue'),
    hotHotmartAppHero: () => import('~/components/Organisms/HotmartAppHero/HotmartAppHero.vue'),
    hotHomeVideo: () => import('~/components/Organisms/HomeVideo/HomeVideo.vue'),
    hotContentBlocks: () => import('~/components/Organisms/ContentBlocks/ContentBlocks.vue'),
    hotYourCommunity: () => import('~/components/Organisms/YourCommunity/YourCommunity.vue'),
    hotMainQuestions: () => import('~/components/Organisms/MainQuestions/MainQuestions.vue'),
    hotSparkleFooter: () => import('~/components/Organisms/Sparkle/SparkleFooter/SparkleFooter.vue'),
  },

  computed: {
    isPortuguese() {
      return Boolean(['pt-br'].includes(this.$i18n.locale))
    },
  },
}
